export const styles = () => ({
  container: {
    flexBasis: '26%',
    borderRight: '1px solid var(--color-issabeline-grey)',
    overflow: 'hidden',
    minWidth: 270,
  },
})
